export const List = [
  {
    type: 'java',
    sales: 38,
  },
  {
    type: 'c',
    sales: 52,
  },
  {
    type: 'c++',
    sales: 61,
  },
  {
    type: 'javascript',
    sales: 145,
  },
  {
    type: 'php',
    sales: 48,
  },
  {
    type: 'ruby',
    sales: 38,
  },
  {
    type: 'nodejs',
    sales: 38,
  },
  {
    type: 'go',
    sales: 38,
  },
];